import { isSharedMailboxAutomapped } from 'owa-account-shared-mailbox-utils';
import { isSharedMailboxInfo } from 'owa-client-types/lib/SharedMailboxInfo';
import { isFeatureEnabled } from 'owa-feature-flags';
import type { CalendarEntry } from 'owa-graph-schema';

export const isAutomappedCalendar = (calendar: CalendarEntry): boolean => {
    return (
        isFeatureEnabled('cal-leftnav-automapped-calendars') &&
        isSharedMailboxInfo(calendar.calendarId.mailboxInfo) &&
        isSharedMailboxAutomapped(calendar.calendarId.mailboxInfo)
    );
};
